import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import { RcButton } from '@components/RcButton';
import { useI18n } from '@shell/composables/useI18n';

interface ClusterRow {
  id?: string;
  canExplore?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClusterExplore',
  props: {
    row: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const { t } = useI18n(store);

const to = computed(() => ({ name: 'c-cluster', params: { cluster: props.row?.id } }));

return (_ctx: any,_cache: any) => {
  return (__props.row.canExplore)
    ? (_openBlock(), _createBlock(_unref(RcButton), {
        key: 0,
        variant: "secondary",
        "data-testid": "cluster-manager-list-explore-management",
        to: to.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('cluster.explore')), 1)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_openBlock(), _createBlock(_unref(RcButton), {
        key: 1,
        variant: "secondary",
        "data-testid": "cluster-manager-list-explore",
        disabled: true
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('cluster.explore')), 1)
        ]),
        _: 1
      }))
}
}

})